import { render, staticRenderFns } from "./FriendReferralPage.vue?vue&type=template&id=32388bef&scoped=true"
import script from "./FriendReferralPage.vue?vue&type=script&lang=js"
export * from "./FriendReferralPage.vue?vue&type=script&lang=js"
import style0 from "./FriendReferralPage.vue?vue&type=style&index=0&id=32388bef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32388bef",
  null
  
)

export default component.exports